/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'menu-hamburger': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M13 18.5c0 .275.225.5.5.5h21c.275 0 .5-.225.5-.5v-3c0-.275-.225-.5-.5-.5h-21c-.275 0-.5.225-.5.5v3zm0 7c0 .275.225.5.5.5h21c.275 0 .5-.225.5-.5v-3c0-.275-.225-.5-.5-.5h-21c-.275 0-.5.225-.5.5v3zm0 7c0 .275.225.5.5.5h21c.275 0 .5-.225.5-.5v-3c0-.275-.225-.5-.5-.5h-21c-.275 0-.5.225-.5.5v3z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/menu-hamburger.js